export const formatUrl = (urlInput) => {
  const url = urlInput.trim();
  const httpsProtocol = 'https://';
  const httpProtocol = 'http://';

  if (url.substr(0, httpsProtocol.length) === httpsProtocol) {
    return url;
  } else if (url.substr(0, httpProtocol.length) === httpProtocol) {
    return httpsProtocol + url.substring(httpProtocol.length);
  } else {
    return httpsProtocol + url;
  }
};
